import { SvgIcon, SvgIconProps } from "@mui/material";

export const DocumentLikeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V7C2.25 3.35 4.35 1.25 8 1.25H16C19.65 1.25 21.75 3.35 21.75 7V17C21.75 20.65 19.65 22.75 16 22.75ZM8 2.75C5.14 2.75 3.75 4.14 3.75 7V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V7C20.25 4.14 18.86 2.75 16 2.75H8Z"
      fill="currentColor"
    />
    <path
      d="M18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
      fill="currentColor"
    />
    <path
      d="M10.2698 18.72C9.38985 18.7 7.37985 17.63 6.76985 15.72C6.33985 14.39 6.83987 12.6301 8.37987 12.1301C9.03987 11.9201 9.71987 12.0101 10.2599 12.3501C10.7999 12.0101 11.4899 11.9201 12.1599 12.1301C13.6999 12.6301 14.1999 14.38 13.7899 15.72C13.1699 17.7 11.0398 18.72 10.2698 18.72ZM8.19987 15.2601C8.61987 16.5501 10.0499 17.19 10.3099 17.22C10.5799 17.19 11.9798 16.5001 12.3598 15.2601C12.5598 14.6001 12.3499 13.7601 11.6999 13.5501C11.4399 13.4701 11.0699 13.5101 10.8999 13.7701C10.7699 13.9801 10.5299 14.1101 10.2899 14.1101C9.99987 14.1101 9.80986 14.0001 9.65986 13.7901C9.45986 13.5101 9.09986 13.4701 8.83986 13.5501C8.19986 13.7601 7.98987 14.6101 8.19987 15.2601Z"
      fill="currentColor"
    />
  </SvgIcon>
);
